/** Default max length for truncated review comment cells on screen; full text appears in tooltips and when printing. */
export const REVIEW_COMMENT_DISPLAY_MAX_LEN = 60;

export function truncateReviewComment(
  text: string | undefined,
  maxLen: number
): { display: string; full: string } {
  const full = (text && text.trim()) || 'No comment';
  if (full.length <= maxLen) return { display: full, full };
  return { display: full.slice(0, maxLen).trim() + '…', full };
}
